import { sendGA4Event } from 'services/analytics-events.service';

import { IEventParams, useEventParamsMethods } from './useEventsParams';

export const useAnalytics = () => {
  const { withWalletAddress, withWalletAddressAndReferrer } = useEventParamsMethods();

  const sendEvent = <T>(eventName: string, params: IEventParams<T> = {}, useReferrer: boolean = true) => {
    const payload = useReferrer ? withWalletAddressAndReferrer(params) : withWalletAddress(params);
    sendGA4Event(eventName, payload);
  };

  return { sendEvent };
};
